<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-card flat>
                  <v-card-text>
                    <template>
                      <v-col cols="12">
                        <div>
                          <v-alert
                            border="bottom"
                            colored-border
                            type="warning"
                            elevation="2"
                          >
                            Para visualizar las imágenes de tipo celular, ingresar desde el mismo dispositivo.
                          </v-alert>
                        </div>
                      </v-col>
                    </template>


                    <template>
                      <!-- HERO -->

                      <v-container class="mt-6">

                        <v-carousel
                          hide-delimiters
                          cycle
                          show-arrows-on-hover
                          height="auto"
                        >

                          <v-carousel-item
                            v-for="(hero, i) in items"
                            :key="hero.id"
                          >

                            <div class="">
                              <v-img
                                :src="hero.image"
                                height="100%"
                              ></v-img>
                            </div>

                          </v-carousel-item>

                        </v-carousel>

                      </v-container>

                      <!-- TRUST -->

                      <v-container>

                        <div class="trust-bar pa-5 pa-md-7">

                          <v-row align="center">

                            <v-col
                              cols="6"
                              md="3"
                              v-for="(trust,i) in trusts"
                              :key="i"
                            >

                              <div class="d-flex align-center">

                                <v-icon
                                  size="42"
                                  color="primary"
                                >
                                  {{ trust.icon }}
                                </v-icon>

                                <div class="ml-4">

                                  <div
                                    class="font-weight-bold"
                                    style="font-size:16px;"
                                  >
                                    {{ trust.title }}
                                  </div>

                                  <div
                                    style="
                                      color:#64748b;
                                      font-size:13px;
                                    "
                                  >
                                    {{ trust.text }}
                                  </div>

                                </div>

                              </div>

                            </v-col>

                          </v-row>

                        </div>

                      </v-container>

                      <!-- CATEGORIES v2 -->
                      <v-container class="mt-14">
                        <div class="section-title">
                          Explora Categorías
                        </div>

                        <div class="section-subtitle">
                          Encuentra rápidamente lo que más buscas
                        </div>

                        <!-- MOBILE -->

                        <div
                          v-if="isMobile"
                          class="categories-scroll"
                        >

                          <div
                            v-for="cat in categories"
                            :key="cat.id"
                            class="category-card"
                          >

                            <img
                              :src="`/static/categories/${cat.icon}`"
                              class="category-img"
                            >

                            <div class="category-name">
                              {{ cat.name }}
                            </div>

                          </div>

                        </div>

                        <!-- DESKTOP -->

                        <div
                          v-else
                          class="categories-grid"
                        >

                          <div
                            v-for="cat in categories.slice(0,7)"
                            :key="cat.id"
                            class="category-card"
                          >

                            <img
                              :src="`/static/categories/${cat.icon}`"
                              class="category-img"
                            >

                            <div class="category-name">
                              {{ cat.name }}
                            </div>

                          </div>

                          <div
                            class="category-card category-all"
                          >

                            <v-icon size="40">
                              mdi-arrow-right
                            </v-icon>

                            <div class="category-name">
                              Ver todas
                            </div>

                          </div>

                        </div>
                      </v-container>

                      <!-- FLASH -->

                      <v-container 
                        class="mt-14"
                        v-for="(fla, i) in flash"
                        :key="fla.id"
                        v-if="!fla.expired"
                      >

                        <div class="flash-sale pa-8 pa-md-12">

                          <v-row align="center">

                            <v-col
                              cols="12"
                              md="7"
                            >

                              <div class="flash-title">
                                {{ fla.title }}
                              </div>

                              <div class="mt-3 text-h6 font-weight-regular">
                                {{ fla.description }}
                              </div>

                              <div class="flash-timer">
                                <div class="time-box">
                                  <div class="time-number">{{ fla.countdown.hours }}</div>
                                  <div class="time-label">Horas</div>
                                </div>

                                <div class="time-box">
                                  <div class="time-number">{{ fla.countdown.minutes }}</div>
                                  <div class="time-label">Min</div>
                                </div>

                                <div class="time-box">
                                  <div class="time-number">{{ fla.countdown.seconds }}</div>
                                  <div class="time-label">Seg</div>
                                </div>
                              </div>

                            </v-col>

                            <v-col
                              cols="12"
                              md="5"
                              class="text-center"
                            >

                              <img
                                :src="fla.image"
                                style="
                                  width:100%;
                                  max-width:340px;
                                  border-radius:26px;
                                  box-shadow:0 15px 35px rgba(0,0,0,.2);
                                "
                              >

                            </v-col>

                          </v-row>

                        </div>

                      </v-container>

                      <!-- MINI SLIDER UX -->

                      <v-container class="mt-16">

                        <v-row
                          align="center"
                          class="mb-4"
                        >

                          <v-col cols="6">

                            <div class="section-title">
                              Tendencias
                            </div>

                          </v-col>

                          <v-col
                            cols="6"
                            class="text-right"
                          >

                            <v-btn
                              text
                              color="primary"
                              class="font-weight-bold"
                            >
                              Explorar
                            </v-btn>

                          </v-col>

                        </v-row>

                        <v-carousel
                          hide-delimiter-background
                          cycle
                          show-arrows-on-hover
                          height="auto"
                        >

                          <v-carousel-item
                            v-for="(tre, i) in trending"
                            :key="i"
                          >

                            <div class="mini-slide-card pa-6 pa-md-10">

                              <v-row align="center">

                                <v-col
                                  cols="12"
                                  md="6"
                                >

                                  <div
                                    :class="!tre.color ? 'primary--text' : ''"
                                    :style="tre.color ? { color: tre.color } : {}"
                                    style="font-weight:800; margin-bottom:14px;"
                                  >
                                    {{ tre.badge ? tre.badge.toUpperCase() : '' }}
                                  </div>

                                  <div
                                    style="
                                      font-size:52px;
                                      font-weight:900;
                                      line-height:1;
                                      color:#0f172a;
                                    "
                                  >
                                    {{ tre.title }}
                                  </div>

                                  <div
                                    class="mt-5"
                                    style="
                                      color:#64748b;
                                      line-height:1.9;
                                    "
                                  >
                                    {{ tre.description }}
                                  </div>

                                  <v-btn
                                    :color="tre.color || 'primary'"
                                    dark
                                    x-large
                                    class="mt-7"
                                    style="
                                      border-radius:18px;
                                      font-weight:800;
                                    "
                                  >
                                    {{ tre.button_text || 'Ver' }}
                                  </v-btn>

                                </v-col>

                                <v-col
                                  cols="12"
                                  md="6"
                                  class="text-center"
                                >

                                  <img
                                    :src="tre.image"
                                    style="
                                      width:100%;
                                      max-width:450px;
                                      border-radius:28px;
                                      box-shadow:
                                      0 18px 45px rgba(0,0,0,.12);
                                    "
                                  >

                                </v-col>

                              </v-row>

                            </div>

                          </v-carousel-item>

                        </v-carousel>

                      </v-container>

                      <!-- MINI SLIDER COLLECTION -->
                      
                      <v-container
                        fluid
                        class="collection-section py-8"
                        v-for="(groupRow, i) in footerList"
                        :key="i"
                      >

                        <v-row justify="center">

                          <v-col
                            cols="12"
                            lg="10"
                            md="11"
                          >

                            <div class="section-header">

                              <div>

                                <div class="section-badge">
                                  COLECCIÓN
                                </div>

                                <div class="section-title">
                                  {{ groupRow.title }}
                                </div>

                                <div class="section-subtitle">
                                  Descubre nuestras novedades
                                </div>

                              </div>

                            </div>

                          </v-col>

                        </v-row>

                        <!-- MOBILE -->

                        <v-row
                          v-if="isMobile"
                          justify="center"
                          class="mt-4"
                        >

                          <v-col
                            cols="12"
                          >

                            <v-carousel
                              cycle
                              interval="5000"
                              hide-delimiters
                              hide-delimiter-background
                              height="auto"
                            >

                              <v-carousel-item
                                v-for="body in groupRow.list"
                                :key="body.id"
                              >

                                <div
                                  class="mobile-banner-wrapper"
                                >

                                  <v-img
                                    :src="body.image"
                                    contain
                                    eager
                                    class="mobile-banner"
                                  />

                                </div>

                              </v-carousel-item>

                            </v-carousel>

                          </v-col>

                        </v-row>

                        <!-- DESKTOP -->

                        <v-row
                          v-else
                          justify="center"
                          class="mt-4"
                        >

                          <v-col
                            cols="12"
                            lg="10"
                            md="11"
                          >

                            <div class="desktop-slider">

                              <v-slide-group
                                show-arrows="always"
                                center-active
                              >

                                <v-slide-item
                                  v-for="body in groupRow.list"
                                  :key="body.id"
                                >

                                  <div
                                    class="desktop-banner-wrapper"
                                  >

                                    <v-img
                                      :src="body.image"
                                      contain
                                      eager
                                      class="desktop-banner"
                                    />

                                  </div>

                                </v-slide-item>

                              </v-slide-group>

                            </div>

                          </v-col>

                        </v-row>

                      </v-container>
                      
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-dialog
                v-model="dialog"
                lg
              >
                <v-card>
                  <v-card-title class="primary dark">
                    <template>
                      <v-tabs
                          v-model="tab"
                          background-color="primary"
                          dark
                      >
                        <v-tab href="#tab-1">Imágenes Cabecera</v-tab>
                        <v-tab href="#tab-2">Imágenes Cuerpo</v-tab>
                        <v-tab href="#tab-3">Imágenes Pies</v-tab>
                      </v-tabs>
                    </template>
                  </v-card-title>

                  <v-card-text>
                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        key="1"
                        value="tab-1"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="banner.group"
                                        :items="select.groups"
                                        item-value="id"
                                        item-text="name"
                                        label="Group"
                                        :rules="[rules.requiredForNull]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="banner.type"
                                        :items="select.type"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="banner.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-file-input
                                        v-model="imagesTmp"
                                        counter
                                        label="Seleccionar Imágenes"
                                        multiple
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected(1)"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmp.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveBanners()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="bannerHeader"
                                    :items="headerList"
                                  >
                                    <template v-slot:item.showImage="{ item }">
                                      <v-row no-gutters>
                                        <v-img :src="item.image" width="70"></v-img>
                                      </v-row>
                                    </template>

                                    <template v-slot:item.type="{ item }">
                                      <template v-if="item.type == 1">MONITOR</template>
                                      <template v-else>CELULAR</template>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                        @click="updateStatus(1, item)"
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                        key="2"
                        value="tab-2"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.sectionId"
                                        :items="select.sections"
                                        item-value="id"
                                        item-text="name"
                                        label="Sección"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerBody.badge"
                                        label="Etiqueta"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerBody.title"
                                        label="Título"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerBody.description"
                                        label="Descripcion"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-dialog
                                        ref="dialog"
                                        v-model="modalOfferEndDate"
                                        persistent
                                        width="290px"
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            v-model="dateText"
                                            label="Fecha y Hora Fin"
                                            readonly
                                            outlined
                                            dense
                                            v-bind="attrs"
                                            v-on="on"
                                          />
                                        </template>

                                        <v-card>
                                          <v-date-picker
                                            v-model="offerDate"
                                            locale="es"
                                            scrollable
                                          />

                                          <v-divider />

                                          <v-time-picker
                                            v-model="offerTime"
                                            format="24hr"
                                          />

                                          <v-card-actions>
                                            <v-spacer />

                                            <v-btn
                                              text
                                              @click="modalOfferEndDate = false"
                                            >
                                              Cancelar
                                            </v-btn>

                                            <v-btn
                                              color="primary"
                                              text
                                              @click="modalOfferEndDate = false"
                                            >
                                              OK
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerBody.buttonText"
                                        label="Texto de Boton"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerBody.color"
                                        label="Color"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.group"
                                        :items="select.groups"
                                        item-value="id"
                                        item-text="name"
                                        label="Grupo"
                                        :rules="[rules.requiredForNull]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <!-- <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.type"
                                        :items="select.type"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col> -->

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerBody.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="8"
                                    >
                                      <v-file-input
                                        v-model="imagesTmpBody"
                                        counter
                                        label="Seleccionar Imágenes"
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected(2)"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmpBody.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveBannersBody()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="bannerBodyHeader"
                                    :items="bodyList"
                                  >
                                    <template v-slot:item.showImage="{ item }">
                                      <v-row no-gutters>
                                        <v-img :src="item.image" width="70"></v-img>
                                      </v-row>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                        @click="updateStatus(2, item)"
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                        key="3"
                        value="tab-3"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="formProductColorImage" v-model="validProductColorImage">
                                <v-container>
                                  <v-row>
                                    <!-- <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerFooter.group"
                                        :items="select.products"
                                        item-value="name"
                                        item-text="name"
                                        label="Productos"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col> -->

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerFooter.group"
                                        :items="select.groups"
                                        item-value="id"
                                        item-text="name"
                                        label="Group"
                                        :rules="[rules.requiredForNull]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerFooter.title"
                                        label="Título"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-text-field
                                        v-model="bannerFooter.group_row"
                                        label="Grupo de Imágenes"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="bannerFooter.status"
                                        :items="select.status"
                                        item-value="id"
                                        item-text="name"
                                        label="Estado"
                                        :rules="[rules.required]"
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="8"
                                    >
                                      <v-file-input
                                        v-model="imagesTmpFooter"
                                        counter
                                        label="Seleccionar Imágenes"
                                        multiple
                                        :show-size="1000"
                                        :rules="[rules.required]"
                                        @change="imagesSelected(3)"
                                        dense
                                        outlined
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                            color="deep-purple accent-4"
                                            dark
                                            label
                                            small
                                          >
                                            {{ text }}
                                          </v-chip>
                                        </template>
                                      </v-file-input>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      class="text-right"
                                    >
                                      <v-btn
                                        :disabled="!validProductColorImage || imagesTmpFooter.length == 0"
                                        color="primary"
                                        block
                                        depressed
                                        @click="saveBannersFooter()"
                                      >
                                        Registrar
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>

                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="bannerFooterHeader"
                                    :items="allRowFooter"
                                  >
                                    <template v-slot:item.showImage="{ item }">
                                      <v-row no-gutters>
                                        <v-img :src="item.image" width="70"></v-img>
                                      </v-row>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                      <v-chip
                                        :color="getColorOrTextStatus(item.status, 'color')"
                                        dark
                                        @click="updateStatus(3, item)"
                                      >
                                        {{ getColorOrTextStatus(item.status, 'text')  }}
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="adm_orange"
                      text
                      @click="dialog = false"
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-row>
          </template>

          <v-btn
            fab
            bottom
            right
            color="primary"
            dark
            fixed
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import firebase from 'firebase'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'HomeImage',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        dialog: false,
        tab: null,
        panel: [0],
        active: null,
        modal: false,
        validProductColorImage: true,
        modalOfferEndDate: false,
        rules: {
          required: v => !!v || 'Por favor completar este campo',
          requiredForNull: v => v !== null && v !== undefined || 'Por favor completar este campo'
        },
        select: {
          products: [],
          groups: [
            { id: '', name: 'TODO LOS PRODUCTOS' },
            { id: 'HOT WHEELS', name: 'HOT WHEELS' },
            { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' },
            { id: 'MINECRAFT', name: 'MINECRAFT' },
            { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' },
            { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' },
            { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' },
            { id: 'BLAZE', name: 'BLAZE' },
            { id: 'SMASHERS', name: 'SMASHERS' },
            { id: 'MUÑECAS', name: 'MUÑECAS' },
            { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' },
            { id: 'NERF', name: 'NERF' },
            { id: 'PLAY DOH', name: 'PLAY DOH' },
            { id: 'SUPER MARIO', name: 'SUPER MARIO' },
            { id: 'PRINCESAS', name: 'PRINCESAS' },
            { id: 'FRIEND', name: 'FRIEND' },
            { id: 'DIDACTICOS', name: 'DIDACTICOS' },
            { id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS', name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS' },
            { id: 'ÚTILES', name: 'ÚTILES' },
            { id: 'MAQUILLAJE', name: 'MAQUILLAJE' },

            { id: 'MENAJES', name: 'MENAJES' },
            { id: 'MAMALONCHERITA', name: 'MAMÁ LONCHERITA' },
            { id: 'BELLEZA', name: 'BELLEZA' },
            { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' },
            { id: 'DEVUELTAALCOLE', name: 'DE VUELTA AL COLE' },
            { id: 'PELUCHESINTERACTIVOS', name: 'PELUCHES INTERACTIVOS' },
            { id: 'DINO', name: 'DINO' },
            { id: 'PAWPATROL', name: 'PAW PATROL' },
            { id: 'BLUEY', name: 'BLUEY' },
            { id: 'SUPERMARIO', name: 'SUPER MARIO' },
            { id: 'JUGUETES', name: 'JUGUETES' },
            { id: 'JUEGOSFAMILIARES', name: 'JUEGOS FAMILIARES' },
            { id: 'BLOQUES', name: 'BLOQUES' },
            { id: 'MUNDOBEBE', name: 'MUNDO BEBE' },
            { id: 'NAVIDAD', name: 'NAVIDAD' }
          ],
          type: [
            { id: '1', name: 'TAMAÑO COMPUTADORA' },
            { id: '100', name: 'TAMAÑO CELULAR' },
          ],
          sections: [],
          status: [
            { id: 1, name: 'ACTIVO' },
            { id: 2, name: 'INACTIVO' }
          ]
        },
        banner: {
          id: null,
          group: null,
          images: [],
          type: null,
          status: null
        },
        bannerHeader: [
          { text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false },
          { text: 'GRUPO', value: 'group' },
          { text: 'ORDEN', value: 'order' },
          { text: 'TIPO', value: 'type' },
          { text: 'ESTADO', value: 'status' },
        ],
        bannerBodyHeader: [
          { text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false },
          { text: 'GRUPO', value: 'group' },
          { text: 'ORDEN', value: 'order' },
          { text: 'ESTADO', value: 'status' },
        ],
        bannerFooterHeader: [
          { text: 'IMAGEN', value: 'showImage', filterable: false, sortable: false },
          { text: 'GRUPO', value: 'group' },
          { text: 'TITULO', value: 'title' },
          { text: 'ORDEN', value: 'order' },
          { text: 'GRUPO DE IMÁGENES', value: 'group_row' },
          { text: 'ESTADO', value: 'status' },
        ],
        bannerBody: {
          id: null,
          sectionId: null,
          badge: null,
          title: null,
          description: null,
          offerEndDate: null,
          buttonText: null,
          color: null,
          group: null,
          images: [],
          type: null,
          status: null
        },
        bannerFooter: {
          id: null,
          group: null,
          title: null,
          group_row: null,
          images: [],
          status: null
        },
        imagesTmp: [],
        imagesTmpBody: [],
        imagesTmpFooter: [],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
        // ************ preview  ************
        device: 1,
        headerList: [],
        bodyList: [],
        footerList: [],
        allRowFooter: [],
        // **********************************
        headerData: [],
        flash: [],
        flashInterval: null,
        trending: [],
        footerList: [],
        categories:[],
        trusts:[
          {
            icon:"mdi-shield-check",
            title:"Compra segura",
            text:"Pagos protegidos"
          },

          {
            icon:"mdi-truck-fast",
            title:"Delivery rápido",
            text:"Lima y provincia"
          },

          {
            icon:"mdi-whatsapp",
            title:"Atención inmediata",
            text:"Respuesta rápida"
          },

          {
            icon:"mdi-sale",
            title:"Ofertas diarias",
            text:"Promociones reales"
          }
        ],
      }
    },
    computed: {
      dateText() {
        if (!this.bannerBody.offerEndDate) return ''

        return moment(this.bannerBody.offerEndDate)
          .format('DD/MM/YYYY HH:mm')
      },

      offerDate: {
        get() {
          if (!this.bannerBody.offerEndDate) return null

          return moment(this.bannerBody.offerEndDate)
            .format('YYYY-MM-DD')
        },

        set(date) {
          const time = this.offerTime || '00:00'

          this.bannerBody.offerEndDate = moment(
            `${date} ${time}`,
            'YYYY-MM-DD HH:mm'
          ).format('YYYY-MM-DD HH:mm:ss')
        }
      },

      offerTime: {
        get() {
          if (!this.bannerBody.offerEndDate) return '00:00'

          return moment(this.bannerBody.offerEndDate)
            .format('HH:mm')
        },

        set(time) {
          const date =
            this.offerDate ||
            moment().format('YYYY-MM-DD')

          this.bannerBody.offerEndDate = moment(
            `${date} ${time}`,
            'YYYY-MM-DD HH:mm'
          ).format('YYYY-MM-DD HH:mm:ss')
        }
      },

      items() {
        return this.headerData.filter(item =>
          this.isMobile
            ? Number(item.type) === 100
            : Number(item.type) === 1
        );
      },

      groupedFooterList() {

        return (list) => {

          const result = [];

          for (let i = 0; i < list.length; i += 3) {

            result.push(
              list.slice(i, i + 3)
            );

          }

          return result;

        };

      },

      isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getColorOrTextStatus(status, type) {
        let value = '';

        if (type === 'color') {
          value = status == 1 ? 'green' : 'red';
        } else if (type === 'text') {
          value = status == 1 ? 'ACTIVO' : 'INACTIVO';
        }

        return value;
      },

      formatDateInit(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      getProducts () {
        axios.get('/secure/products')
        .then(response => {
          this.select.products = response.data;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      saveBanners() {
        this.overlay = true;

        const request = {
          id: this.banner.id,
          group: this.banner.group,
          type: this.banner.type,
          images: JSON.stringify(this.banner.images),
          status: this.banner.status
        }

        axios.post(process.env.DINO.PATH.SAVE_BANNER_HEADER, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
          this.getBanners();
        });
      },

      saveBannersBody() {
        this.overlay = true;

        const request = {
          id: this.bannerBody.id,
          sectionId: this.bannerBody.sectionId,
          badge: this.bannerBody.badge,
          title: this.bannerBody.title,
          description: this.bannerBody.description,
          offerEndDate: this.bannerBody.offerEndDate,
          buttonText: this.bannerBody.buttonText,
          color: this.bannerBody.color,
          group: this.bannerBody.group,
          type: this.bannerBody.type,
          images: JSON.stringify(this.bannerBody.images),
          status: this.bannerBody.status
        }

        axios.post(process.env.DINO.PATH.SAVE_BANNER_BODY, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
          this.getBanners();
        });
      },

      saveBannersFooter() {
        this.overlay = true;

        const request = {
          id: this.bannerFooter.id,
          group: this.bannerFooter.group,
          title: this.bannerFooter.title,
          group_row: this.bannerFooter.group_row,
          images: JSON.stringify(this.bannerFooter.images),
          status: this.bannerFooter.status
        }

        axios.post(process.env.DINO.PATH.SAVE_BANNER_FOOTER, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.onUpload();
        })
        .then(() => {
          this.$refs.formProductColorImage.reset();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
          this.getBanners();
        });
      },

      onUpload() {
        const storage = firebase.storage();
        const metadata = {
          cacheControl: "public, max-age=31536000"
        };

        if (this.tab == 'tab-1') {
          this.imagesTmp.map((file, index) => {
            let task = storage.ref(`/img/banners/${file.name}`).put(file, metadata);
          });
        } else if (this.tab == 'tab-2') {
          const file = this.imagesTmpBody;

          const task = storage
            .ref(`/img/banners-body/${file.name}`)
            .put(file, metadata);
        } else if (this.tab == 'tab-3') {
          this.imagesTmpFooter.map((file, index) => {
            let task = storage.ref(`/img/banners-footer/${file.name}`).put(file, metadata);
          });
        }
      },

      imagesSelected(type) {
        const domain = 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img';
        let img = [];

        if (type == 1) {
          this.imagesTmp.map((file, index) => {
            let order = index + 1;

            let image = encodeURIComponent(`/banners/${file.name}`);
            image = domain.concat(`${image}?alt=media`);
            img.push({ image: image, order: order, name: file.name});
          });

          this.banner.images = img;
        } else if (type == 2) {
          const file = this.imagesTmpBody;

          this.bannerBody.images = [{
            image: `${domain}${encodeURIComponent(`/banners-body/${file.name}`)}?alt=media`,
            order: 1,
            name: file.name
          }];
        } else if (type == 3) {
          this.imagesTmpFooter.map((file, index) => {
            let order = index + 1;

            let image = encodeURIComponent(`/banners-footer/${file.name}`);
            image = domain.concat(`${image}?alt=media`);
            img.push({ image: image, order: order, name: file.name});
          });

          this.bannerFooter.images = img;
        }
      },

      getBanners() {
        axios.get(process.env.DINO.PATH.GET_BANNERS)
        .then(response => {
          this.headerList = response.data.header;
          this.bodyList = response.data.body;
          this.footerList = response.data.footer;
          this.allRowFooter = response.data.allRowFooter;
          this.select.sections = response.data.section;
        });
      },

      updateStatus(type, item) {
        const request = {
          type: type,
          id: item.id,
          status: item.status == 1 ? 0 : 1
        }

        axios.post(process.env.DINO.PATH.UPDATE_BANNER_STATUS, request)
        .then(response => {
          this.showMessage(response.data.message, 'green');
        })
        .then(() => {
          this.getBanners();
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
      },

      loadHome() {
        axios.get(`${process.env.DINO.PATH.GET_BANNERS}?loadHome=true`)
          .then(response => {
            this.categories = response.data.modul;
            this.headerData = response.data.header;

            const flash = response.data.body.filter(item =>
              item.section && item.section.name == 'Ofertas'
            )
            .map(item => ({
              ...item,
              countdown: {
                hours: '00',
                minutes: '00',
                seconds: '00'
              },
              expired: false
            }))

            const trending = response.data.body.filter(item =>
              item.section && item.section.name == 'Tendencias'
            )

            this.flash = flash;
            this.trending = trending;
            this.footerList = response.data.footer;

            this.startFlashCountdown();

            localStorage.setItem('header', JSON.stringify(this.headerData));
            localStorage.setItem('flash', JSON.stringify(flash));
            localStorage.setItem('trending', JSON.stringify(trending));
            localStorage.setItem('footer', JSON.stringify(response.data.footer));
          })
          .catch(err => {
            this.headerData = JSON.parse(localStorage.getItem('header'));
            this.flash = JSON.parse(localStorage.getItem('flash'));
            this.trending = JSON.parse(localStorage.getItem('trending'));
            this.footerList = JSON.parse(localStorage.getItem('footer'));
          });
      },
      startFlashCountdown() {
        this.flashInterval = setInterval(() => {
          this.flash.forEach(item => {

            const end = new Date(item.offer_end_date.replace(' ', 'T')).getTime()
            const now = Date.now()
            const diff = end - now

            if (diff <= 0) {
              item.expired = true
              item.countdown = {
                hours: '00',
                minutes: '00',
                seconds: '00'
              }
              return
            }

            const hours = Math.floor(diff / (1000 * 60 * 60))
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((diff % (1000 * 60)) / 1000)

            item.countdown = {
              hours: String(hours).padStart(2, '0'),
              minutes: String(minutes).padStart(2, '0'),
              seconds: String(seconds).padStart(2, '0')
            }

          })

        }, 1000)
      },
    },
    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getBanners();
      this.loadHome();
      this.getProducts();
    },
    watch: {
      dialog (val) {
        if (val === false) {
          this.active = null;
          this.tab = 'tab-1';
        }
      }
    }
  }
</script>
<style scoped>
  /* HERO */

  .hero{
    position:relative;
    overflow:hidden;
    border-radius:38px;
    min-height:620px;
    box-shadow: 0 25px 60px rgba(0,0,0,.15);
  }

  /* .hero-overlay{
    position:absolute;
    inset:0;
    background:
    linear-gradient(
    90deg,
    rgba(0,0,0,.72),
    rgba(0,0,0,.25),
    rgba(0,0,0,.05)
    );
    z-index:2;
  } */

  .hero-content{
    position:absolute;
    z-index:3;
    top:50%;
    left:70px;
    transform:translateY(-50%);
    max-width:560px;
    color:white;
  }

  .hero-badge{
    display:inline-flex;
    align-items:center;
    background:rgba(255,255,255,.18);
    backdrop-filter:blur(12px);
    padding:10px 18px;
    border-radius:999px;
    font-weight:700;
    margin-bottom:24px;
  }

  .hero-title{
    font-size:72px;
    line-height:1;
    font-weight:900;
    letter-spacing:-3px;
    margin-bottom:24px;
  }

  .hero-sub{
    font-size:19px;
    opacity:.92;
    line-height:1.8;
    margin-bottom:32px;
  }

  .hero-btn{
    height:62px !important;
    padding:0 34px !important;
    border-radius:20px !important;
    font-weight:800 !important;
    font-size:16px !important;
    box-shadow:
    0 14px 30px rgba(255,77,109,.45);
  }

  /* NUEVO HERO MOBIL */
  @media(max-width:960px){
    .hero{
      min-height:350px;
      border-radius:24px;
    }
  }

  @media(max-width:960px){
    .hero-content{
      left:24px;
      right:24px;
      max-width:none;
      text-align: center;
    }

    .hero-title{
      font-size:38px;
      letter-spacing:-1px;
    }

    .hero-sub{
      font-size:16px;
      line-height:1.6;
    }
  }

  /* TRUST BAR */

  .trust-bar{
    background:white;
    border-radius:24px;
    margin-top:-45px;
    position:relative;
    z-index:5;
    box-shadow:
    0 18px 45px rgba(0,0,0,.08);
    border:1px solid #edf2f7;
  }

  /* CATEGORIES V2 */
  .categories-grid{
    display:grid;
    grid-template-columns:
      repeat(4,1fr);
    gap:20px;
    margin-top:30px;
  }

  .category-card{
    background:white;
    border-radius:22px;
    padding:18px;
    text-align:center;
    cursor:pointer;
    transition:.25s;
    border:1px solid #edf2f7;
  }

  .category-card:hover{
    transform:
      translateY(-6px);
    box-shadow:
      0 12px 30px rgba(0,0,0,.08);
  }

  .category-img{
    width:90px;
    height:90px;
    object-fit:cover;
    /* border-radius:18px; */
  }

  .category-name{
    margin-top:12px;
    font-weight:700;
  }

  .category-all{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
  }

  .categories-scroll{
    display:flex;
    gap:20px;
    overflow-x:auto;
    padding-bottom:10px;
    scrollbar-width:none;
  }

  .categories-scroll::-webkit-scrollbar{
    display:none;
  }

  /* FLASH */

  .flash-sale{
    background:
    linear-gradient(
      135deg,
      #dc2e3d,
      #e6667d
    );

    border-radius:30px;
    overflow:hidden;
    position:relative;
    color:white;
    box-shadow:
      0 18px 40px rgba(255,77,109,.28);
  }

  .flash-title{
    font-size:40px;
    font-weight:800;
  }

  .flash-timer{
    display:flex;
    gap:12px;
    margin-top:20px;
  }

  .time-box{
    background:rgba(255,255,255,.18);
    backdrop-filter:blur(10px);
    border-radius:18px;
    padding:14px;
    min-width:72px;
    text-align:center;
  }

  .time-number{
    font-size:28px;
    font-weight:800;
  }

  .time-label{
    font-size:12px;
    opacity:.9;
  }

  /* MINI SLIDER */

  .mini-slide-card{
    background:white;
    border-radius:30px;
    overflow:hidden;
    border:1px solid #edf2f7;
    box-shadow:
    0 12px 35px rgba(0,0,0,.06);
  }

  /* MOBILE */

  @media(max-width:960px){

    .hero{
      min-height:650px;
    }

    .hero-content{
      left:28px;
      right:28px;
    }

    .hero-title{
      font-size:52px;
    }

    .section-title{
      font-size:32px;
    }

  }

  @media(max-width:600px){

    .hero{
      min-height:580px;
      border-radius:26px;
    }

    .hero-title{
      font-size:38px;
      letter-spacing:-2px;
    }

    .hero-sub{
      font-size:15px;
    }

    .hero-content{
      top:auto;
      bottom:40px;
      transform:none;
    }

    .section-title{
      font-size:26px;
    }

    .product-image{
      height:220px;
    }

    .new-price{
      font-size:26px;
    }

    .cat-card{
      min-width:145px;
    }

    .cat-img{
      height:120px;
    }

    .mini-title{
      font-size:24px;
    }

  }


  /* MINI SLIDER COLLECTION */

  .collection-section{
    position:relative;
  }

  .section-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
  }

  .section-badge{
    display:inline-flex;
    padding:8px 14px;
    border-radius:999px;
    background:#eef4ff;
    color:#1565ff;
    font-size:12px;
    font-weight:800;
    letter-spacing:.5px;
    margin-bottom:12px;
  }

  .section-title{
    font-size:38px;
    font-weight:900;
    color:#0f172a;
    line-height:1;
  }

  .section-subtitle{
    margin-top:10px;
    color:#64748b;
    font-size:15px;
  }

  /* DESKTOP */

  .desktop-slider{
    overflow:hidden;
  }

  .desktop-banner-wrapper{
    width:320px;
    margin:0 12px;
    cursor:pointer;
    transition:.35s;
  }

  .desktop-banner-wrapper:hover{
    transform:
      translateY(-8px);
  }

  .desktop-banner{
    border-radius:24px;
    overflow:hidden;
    box-shadow:
      0 12px 35px rgba(0,0,0,.08);
  }

  /* MOBILE */

  .mobile-banner-wrapper{
    padding:4px;
  }

  .mobile-banner{
    border-radius:22px;
    overflow:hidden;
    box-shadow:
      0 12px 35px rgba(0,0,0,.08);
  }

  /* FLECHAS */

  .v-slide-group__prev,
  .v-slide-group__next{
    min-width:52px !important;
  }

  .v-slide-group__prev .v-icon,
  .v-slide-group__next .v-icon{
    font-size:34px !important;
    color:#1565ff;
  }

  /* RESPONSIVE */

  @media(max-width:960px){
    .section-header{
      display:block;
    }

    .section-title{
      font-size:30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/HomeImage.vue